<template>
  <div class="user-form">
    <img class="logo" alt="ADRAYN" :src="$ComDomain.base + 'static/images/logo.png'">
    <h1><span>{{ copyright.title }} &#8226; {{ actions.simpleReg }}</span></h1>
    <Form>
      <div class="form-group">
        <Poptip v-model="mobileError" :content="warn.mobile" placement="bottom">
          <span :class="{'input-group-addon':1, 'text-primary':mobileFocus}" @click="mobileFocus=1"><Icon type="md-phone-portrait"></Icon> {{ userform.field.mobile }}</span>
          <input v-focus="mobileFocus" @keyup.enter="codeFocus=1" @input="mobileError=false" @focus="mobileFocus=1" @blur="mobileFocus=0" v-model="user.mobile" style="padding-left:75px" type="text" autocomplete="off" />
        </Poptip>
      </div>
      <code-getter process="reg" ref="CodeGetter" v-focus="codeFocus" @focus="codeFocus=1" @blur="codeFocus=0" :user="user" :mobileError="mobileError" @done="doReg" @validate="validateMobile"></code-getter>
      <div class="form-group">
        <Button type="success" @click="doReg" shape="circle">{{ actions.reg }}</Button>
      </div>
    </Form>
    <div style="text-align:center;margin-top:-4px">
      <a role="button" @click="$store.commit('userEnter', {action: 'login'})">{{ actions.loging }}</a>
    </div>
  </div>
</template>
<script>
import { Icon, Button, Form } from 'iview'
import { copyright, message, userform, actions } from '../../locale'
import { validatePhone, vFocus } from '../../utils'
import CodeGetter from '../CodeGetter'
import Poptip from './Poptip'

export default {
  name: 'SimpleReg',
  data() {
    return {
      copyright,
      actions,
      userform,
      mobileFocus: 0,
      passwordFocus: 0,
      mobileError: false,
      passwordError: false,
      codeFocus: 0,
      warn: {
        mobile: ''
      },
      user: {
        mobile: '',
        ic: ''
      }
    }
  },
  directives: {
    focus: vFocus
  },
  watch: {
    $route(to, from) {
      this.mobileError = false
    }
  },
  methods: {
    validateMobile() {
      let result = validatePhone(this.user.mobile)
      this.user.mobile = result.correct
      this.warn.mobile = result.text
      this.mobileFocus = this.mobileError = result.error
      if (!result.error) return true
    },
    doReg() {
      if (!this.validateMobile()) {
        return
      }
      this.$refs.CodeGetter.$emit('validate-then', () => {
        global.$ComAxios.post(this.$ComDomain.User.register, this.user)
          .then(response => {
            if (response.status == 200 && response.data.status == 200) {
              global.$Modal.info({
                title: message.title.info,
                render: (h) => {
                  return h('p', userform.hint.plainword.replace('%', response.data.plainCode))
                },
                onOk: () => {
                  this.$store.dispatch('login', response.data).then(() => {
                    this.$router.push(this.$route.params.to)
                  })
                }
              })
            } else {
              this.$Message.error(response.data.msg || message.content.error.replace('%', actions.reg))
            }
          })
      })
    }
  },
  components: {
    Icon,
    Button,
    Form,
    CodeGetter,
    Poptip
  }
}

</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/commons/components/login/SimpleReg.vue